import { render } from "./newClients.vue?vue&type=template&id=1721ed78&scoped=true"
import script from "./newClients.vue?vue&type=script&lang=js"
export * from "./newClients.vue?vue&type=script&lang=js"

import "./newClients.vue?vue&type=style&index=0&id=1721ed78&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1721ed78"]])

export default __exports__